import { StatusCode, http, isFetchError } from '~~core';

import { TokenInfoSchema } from '../schemas/token';

export async function resendToken(signatureRequestKey: string, step: string) {
  const data = await http(`/notarial/widget/signatures/${signatureRequestKey}/token/resend?step=${step}`, {
    method: 'post',
  });

  return TokenInfoSchema.parse(data);
}

export async function sendToken(requestKey: string, step: string) {
  let data;

  try {
    data = await http(`/notarial/widget/signatures/${requestKey}/token?step=${step}`, {
      method: 'post',
    });

    return TokenInfoSchema.parse(data);
  } catch {
    return TokenInfoSchema.parse({
      validUntil: new Date().toISOString(),
      used: false,
      resend: {
        remainingAttempts: Number.POSITIVE_INFINITY,
        blockedUntil: new Date().toISOString(),
      },
    });
  }
}

export async function fetchTokenExpirationInfo(requestKey: string, step: string) {
  let data;

  try {
    data = await http(`/notarial/widget/signatures/${requestKey}/token?step=${step}`, {
      method: 'get',
    });
  } catch (err) {
    if (!isFetchError(err)) throw err;
    if (err.status !== StatusCode.NOT_FOUND) throw err;

    data = await sendToken(requestKey, step);
  }

  return TokenInfoSchema.parse(data);
}
